import { Link } from "wouter";
import {
  TrendingUp,
  ArrowRight,
  Wheat,
  Users,
  Target,
  Scale,
} from "lucide-react";

import { PageHeader } from "@/components/layout/page-header";
import { DataCard } from "@/components/data/data-card";
export default function RelatoriosPage() {
  // Sem `color`/`bgColor` por relatório: a cor decorativa diferente em cada
  // atalho fazia cinco tratamentos para cinco itens que são a mesma coisa — um
  // link para uma tela. O ícone distingue; a cor não precisa.
  const relatorios = [
    {
      id: 'performance-setor',
      titulo: 'Performance por Setor',
      descricao: 'Análise detalhada de desempenho por setor e ciclo, incluindo planejado, colhido, perdas e status',
      icon: TrendingUp,
      href: '/cacho/relatorios/performance-setor',
    },
    {
      id: 'produtividade-familia',
      titulo: 'Produtividade da Família',
      descricao: 'Desempenho de colheita e produtividade por área, com detalhamento por fita',
      icon: Users,
      href: '/cacho/relatorios/produtividade-familia',
    },
    {
      id: 'cachos-colher',
      titulo: 'Cachos a Colher',
      descricao: 'Previsão mensal de colheita agrupada por setor com filtros por período',
      icon: Wheat,
      href: '/cacho/relatorios/cachos-colher',
    },
    {
      id: 'previsto-realizado',
      titulo: 'Previsto vs Realizado',
      descricao: 'Maturação prevista vs realizada por variedade e mês, para calibrar o cadastro de Variedades',
      icon: Target,
      href: '/cacho/relatorios/previsto-realizado',
    },
    {
      id: 'rendimento-por-setor',
      titulo: 'Rendimento por Setor',
      descricao: 'kg por cacho por setor, mês e variedade, a partir das colheitas com venda vinculada',
      icon: Scale,
      href: '/cacho/relatorios/rendimento-por-setor',
    },
  ];

  return (
    <div className="space-y-6 md:space-y-8">
      <PageHeader titulo="Relatórios" descricao="Análise de desempenho e produtividade" />

      {/* Relatórios Grid — mesmo tratamento em todos: um card por atalho, ícone
          em `text-muted-foreground`, sem cor decorativa por item. */}
      <div className="grid gap-3 md:grid-cols-2 lg:grid-cols-3">
        {relatorios.map((relatorio) => (
          <Link key={relatorio.id} href={relatorio.href}>
            <DataCard
              className="h-full hover-elevate cursor-pointer transition-all"
              testId={`card-relatorio-${relatorio.id}`}
              titulo={relatorio.titulo}
              acao={<relatorio.icon className="h-4 w-4 text-muted-foreground" />}
              rodape={
                <span className="flex items-center text-primary font-medium">
                  Ver relatório
                  <ArrowRight className="h-4 w-4 ml-1" />
                </span>
              }
              padded
            >
              <p className="text-sm text-muted-foreground">{relatorio.descricao}</p>
            </DataCard>
          </Link>
        ))}
      </div>
    </div>
  );
}
